import React from 'react'
import {createRoot} from 'react-dom/client'
import './index.css'
import App from './App'
import { CookiesProvider } from 'react-cookie'

const root = createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <CookiesProvider>
      <App />
    </CookiesProvider>
  </React.StrictMode>,
)
